"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createSweepRuleForSenderRequest_1 = require("owa-service/lib/factory/createSweepRuleForSenderRequest");
var createSweepRuleForSenderOperation_1 = require("owa-service/lib/operation/createSweepRuleForSenderOperation");
var Utils_1 = require("owa-service/lib/Utils");
/**
 * Helper function to create the empty rule names array which has the same length of the emailAddresses array.
 * This is a workaround for server validation and will be removed after fixing
 * VSO 8796: Improve validation for utah CreateSweepRuleForSenderAction
 */
function createRuleNames(emailAddresses) {
    return emailAddresses.map(function (email) {
        return '';
    });
}
/**
 * Apply bulk item action service
 * @param emailAddresses the email addresses to be blocked
 * @return the ApplyBulkItemActionResponse
 */
function blockSenderService(emailAddresses) {
    var requestBody = createSweepRuleForSenderRequest_1.default({
        EmailAddresses: emailAddresses,
        ActionType: 2 /* Block */,
        RuleName: null /* deprecated required param*/,
        RuleNames: createRuleNames(emailAddresses),
    });
    return createSweepRuleForSenderOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = blockSenderService;
//# sourceMappingURL=blockSenderService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/blockSenderService.js
// module id = 5664
// module chunks = 62